<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Foreword">Foreword, by Alan Munde</a></p>
<p class="TOC"><a href="#/Preface">Preface, by Jeff Campbell</a></p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction, by Braeden Paul</a></p>
<p class="TOC1"><a href="#/Riley">Riley Gilbreath</a></p>
<p class="TOC1"><span href="#/Part01" title="Link target outside of Sample">P<span class="small">ART</span> I. F<span class="small">AMILIES</span></span></p>
<p class="TOC"><span href="#/Chapter01" title="Link target outside of Sample">Banjo Ben and the Purple Hulls</span></p>
<p class="TOC"><span href="#/Chapter02" title="Link target outside of Sample">The Cooke Brothers</span></p>
<p class="TOC"><span href="#/Chapter03" title="Link target outside of Sample">Born in Texas</span></p>
<p class="TOC"><span href="#/Chapter04" title="Link target outside of Sample">Jesse Brock (C.W. Brock Family)</span></p>
<p class="TOC"><span href="#/Chapter05" title="Link target outside of Sample">The Davis Brothers (Greg and Brad)</span></p>
<p class="TOC"><span href="#/Chapter06" title="Link target outside of Sample">Chuck Lee: Santa Makes Banjos</span></p>
<p class="TOC"><span href="#/Chapter07" title="Link target outside of Sample">The Pyeatt Family</span></p>
<p class="TOC"><span href="#/Chapter08" title="Link target outside of Sample">The Steel Drivin’ Fiddler</span></p>
<p class="TOC"><span href="#/Chapter09" title="Link target outside of Sample">The Vestal Brothers (Scott and Curtis)</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">The Whites</span></p>
<p class="TOC1"><span href="#/Part02" title="Link target outside of Sample">P<span class="small">ART</span> II. M<span class="small">ENTORS</span></span></p>
<p class="TOC"><span href="#/Chapter11" title="Link target outside of Sample">A Dawg and a Herd of Longhorns</span></p>
<p class="TOC"><span href="#/Chapter12" title="Link target outside of Sample">Camp Bluegrass at South Plains College</span></p>
<p class="TOC"><span href="#/Chapter13" title="Link target outside of Sample">High Plains Jamboree</span></p>
<p class="TOC"><span href="#/Chapter14" title="Link target outside of Sample">From Grapeland to Austin: An Interview with Andi Jo Huff</span></p>
<p class="TOC"><span href="#/Chapter15" title="Link target outside of Sample">The Lone Star Guitar Prodigy</span></p>
<p class="TOC"><span href="#/Chapter16" title="Link target outside of Sample">Pickin’ on the Square</span></p>
<p class="TOC"><span href="#/Chapter17" title="Link target outside of Sample">Jade Throneberry’s Full Plate</span></p>
<p class="TOC"><span href="#/Chapter18" title="Link target outside of Sample">Play It Forward</span></p>
<p class="TOC1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?21b3ccb8